﻿import React, { useContext, useMemo } from 'react';
import Context, { context_type } from '@Util/Context';
import { P } from '@Elements/Fonts';
import { Icon_Account_Circle } from '@Elements/ImageElements/Icons';

const User_Details: React.FC = React.memo(() => {
    const { logged_in_user }: context_type = useContext(Context);

    const return_employee_role = useMemo(() => {
        if (!logged_in_user) return "";

        let role_str = logged_in_user.settings?.employeeRole || "";

        if (logged_in_user.isAdmin) {
            role_str += role_str ? " (Admin)" : "(Admin)";
        }

        return role_str;
    }, [logged_in_user]);

    return (
        <div className="Dynamic_Island_User_Menu_Current_User">
            <div className="Dynamic_Island_User_Menu_Current_User_Photo">
                {
                    logged_in_user?.photo?.fileUrl ?
                        <img
                            src={logged_in_user?.photo?.fileUrl}
                            alt={`${logged_in_user?.firstName || ""} ${logged_in_user?.lastName || ""}`}
                        /> :
                        <Icon_Account_Circle />
                }
            </div>
            <div className="Dynamic_Island_User_Menu_Current_User_Details">
                <P bold={true}>{`${logged_in_user?.firstName || ""} ${logged_in_user?.lastName || ""}`}</P>
                <P small={true} secondary={true}>{return_employee_role}</P>
            </div>
        </div>
    );
});

export default User_Details;